// Message value object: the conversation-message vocabulary + a small factory, so
// message `type` values stop being magic strings scattered across flows, hooks, and
// constants. This is a pure leaf module (no imports) — safe for any layer to depend on.

/** Legacy persisted value for the agent type, before it was normalized to lowercase. */
export const LEGACY_AGENT_TYPE = 'AGENT';

/**
 * Canonical message-type vocabulary. All values are lowercase (AGENT was normalized
 * from the legacy uppercase 'AGENT' — see normalizeLegacyMessageType for how already-
 * persisted rows are coerced on read). IMAGE / IMAGE_FALLBACK are legacy standalone
 * Sprinklr image types kept for rows persisted before agent images embedded their
 * image data on the message.
 */
export const MessageType = {
  USER: 'user',
  BOT: 'bot',
  SYSTEM: 'system',
  ADD_TO_CART: 'add-to-cart',
  AGENT: 'agent',
  IMAGE: 'image',
  IMAGE_FALLBACK: 'imageFallback',
};

/**
 * Coerce a legacy persisted message onto the canonical vocabulary at read time — today
 * just the uppercase 'AGENT' → MessageType.AGENT. Non-destructive: no IndexedDB version
 * bump / migration (the DB is shared with thd-storage-utils' initIndexDB at v2). Returns
 * the same object reference when nothing needs coercing, so it is safe upstream of
 * reconcileMessages' identity check.
 * @param {Object} message
 * @returns {Object}
 */
export const normalizeLegacyMessageType = (message) => (
  message?.type === LEGACY_AGENT_TYPE ? { ...message, type: MessageType.AGENT } : message
);

/**
 * Build a conversation-message payload. `type` + `content` are the shape's spine;
 * `extras` (messageOrigin, variant, image metadata, error, …) are merged as-is.
 * Persistence fields (sessionId, timestamp, feedbackProvided, updatedAt) are stamped
 * later by useMessageHistory.saveMessage, not here.
 * @param {string} type - a MessageType value
 * @param {*} content
 * @param {Object} [extras]
 * @returns {Object}
 */
export const createMessage = (type, content, extras = {}) => ({
  type,
  content,
  ...extras,
});
